import Lottie from 'lottie-react';
import MagicWand from '../jsons/magic-wand-loop-cycle.json';


const LottieMagicWand = props => {
  return <Lottie animationData={MagicWand} loop={true} {...props} />;
};

export default LottieMagicWand;
